import React, { useState } from "react";
import {
    Box,
    Modal,
    IconButton,
    Slide,
    Grid,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { DARKCOLORS, LIGHTCOLORS } from "../../../Utils/constants";
import { useThemeContext } from "../../../Context/ThemeContext";
import { useTranslation } from "react-i18next";
import useMediaQuery from '@mui/material/useMediaQuery';

const DietaryPreferencesModal = ({ open, onClose, onSave, selectedTags = [], tags }) => {
    const { t } = useTranslation();
    const { mode } = useThemeContext();

    const [localSelectedTags, setLocalSelectedTags] = useState(selectedTags);  // State to manage the selected tags locally
    const isSmall = useMediaQuery('(max-width:410px)');

    const btnColor = mode === 'dark' ? DARKCOLORS.Primary500 : LIGHTCOLORS.Primary500;
    const inputBoxColor = mode === 'dark' ? DARKCOLORS.GreyScale10 : LIGHTCOLORS.GreyScale10;
    const textborderColor = mode === 'dark' ? DARKCOLORS.GreyScale90 : LIGHTCOLORS.GreyScale90;
    const inputBoxColor1 = mode !== 'dark' ? DARKCOLORS.GreyScale10 : LIGHTCOLORS.GreyScale10;
    const textborderColor1 = mode !== 'dark' ? DARKCOLORS.GreyScale90 : LIGHTCOLORS.GreyScale90;
    const cardColor = mode === 'dark' ? DARKCOLORS.BackgroundCard : LIGHTCOLORS.BackgroundCard;

    // Handle tag selection
    const handleTagClick = (label) => {
        const isSelected = localSelectedTags.includes(label);
        const updatedTags = isSelected
            ? localSelectedTags.filter((tag) => tag !== label)
            : [...localSelectedTags, label];
        setLocalSelectedTags(updatedTags);  // Update local state
    };

    // Handle reset
    const handleReset = () => {
        setLocalSelectedTags([]); // Reset selected tags
        onSave([])
    };

    return (
        <Modal open={open} onClose={onClose} closeAfterTransition>
            <Slide direction="left" in={open} mountOnEnter unmountOnExit timeout={600}>
                <Box
                    sx={{
                        top: "10%",
                        right: "3.5%",
                        position: "absolute",
                        transform: "translate(-50%, -50%)",
                        width: 581,
                        bgcolor: cardColor,
                        borderRadius: "24px",
                        p: 3,
                        '@media (max-width: 600px)': {
                            width: "97%",
                            right: "1.5%",
                        },
                    }}>
                    <Box>
                        {/* Header */}
                        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 6 }}>
                            <h2 className="addmachine-text-heading1" style={{ margin: "0px" }}>{t('vendingMachines.foodPreferences')}</h2>
                            <IconButton sx={{ p: 0 }} onClick={onClose}>
                                <CloseIcon />
                            </IconButton>
                        </Box>

                        <Box sx={{ mx: isSmall ? 0 : 5 }}>
                            <p id="popup-text-id1" className="popup-text" style={{ textAlign: "center" }}>{t('vendingMachines.foodPreferencesText')}</p>
                            {/* Tags Section */}
                            <Grid container spacing={2}>
                                {tags.map(({ IconComponent, label }, index) => (
                                    <Grid
                                        item
                                        xs={4}
                                        sm={4}
                                        key={index}
                                        sx={{
                                            display: "flex",
                                            flexDirection: "column",
                                            alignItems: "center",
                                            position: "relative", // For positioning the slash
                                        }}
                                    >
                                        <Box
                                            onClick={() => handleTagClick(label)}
                                            sx={{
                                                display: "flex",
                                                flexDirection: "column",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                width: 80,
                                                height: 80,
                                                bgcolor: localSelectedTags.includes(label) ? inputBoxColor1 : inputBoxColor,
                                                borderRadius: "50%",
                                                boxShadow: `0 2px 4px ${mode === "dark" ? "rgba(0, 0, 0, 0.5)" : "rgba(0, 0, 0, 0.1)"}`,
                                                mb: 1,
                                                position: "relative", // Ensure slash appears within the circle
                                                cursor: "pointer",
                                                '@media (max-width: 600px)': {
                                                    width: 50,
                                                    height: 50,
                                                    right: "5%"
                                                }
                                            }}
                                        >
                                            {/* Icon Component */}
                                            {(label === "Fish-Free" || label === "Gluten-Free" || label === "Lactose-Free") && (
                                                <Box
                                                    sx={{
                                                        position: "absolute",
                                                        top: 0,
                                                        left: 0,
                                                        width: "100%",
                                                        height: "100%",
                                                        transform: "rotate(-45deg)", // Rotate the slash
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        "&::before": {
                                                            content: '""',
                                                            position: "absolute",
                                                            width: "100%", // Ensure it covers the full circle
                                                            height: "1px", // Thickness of the slash
                                                            bgcolor: localSelectedTags.includes(label) ? textborderColor1 : textborderColor,// Match the theme
                                                        },
                                                    }}
                                                />
                                            )}
                                            <IconComponent color={localSelectedTags.includes(label) ? textborderColor1 : textborderColor} />
                                        </Box>
                                        <p id="popup-text-id" className="popup-text-id" style={{ textAlign: "center", marginBottom: "2rem" }}>{label}</p>
                                    </Grid>
                                ))}
                            </Grid>
                        </Box>

                        {/* Actions */}
                        <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2, mt: 3 }}>
                            <button type="button" style={{ border: `1px solid ${btnColor}`, color: btnColor }} onClick={handleReset}
                                className="cancel-btn">{t('vendingMachines.reset')}</button>
                            <button type="button" style={{ background: btnColor }} onClick={() => onSave(localSelectedTags)}
                                className="save-btn">{t('vendingMachines.apply')}</button>
                        </Box>
                    </Box>
                </Box>
            </Slide>
        </Modal>
    );
};

export default DietaryPreferencesModal;
